import type { Meta, StoryObj } from '@storybook/angular';
import { moduleMetadata } from '@storybook/angular';
import { expect } from 'storybook/test';
import { HeaderTopComponent } from '../../app/content/layout/components/general/header/components/header-top/header-top.component';
import { withCommonDecorators } from '../_utils/story-helpers';

const meta: Meta = {
  title: 'Compositions/Header Assembly',
  tags: ['autodocs'],
  decorators: [
    ...withCommonDecorators(),
    moduleMetadata({
      imports: [HeaderTopComponent],
    }),
  ],
  parameters: {
    layout: 'fullscreen',
    docs: {
      description: {
        component: 'Header composition showing the top bar with USP links, Trustpilot, and country selector.',
      },
    },
  },
};
export default meta;
type Story = StoryObj;

export const HeaderTopBar: Story = {
  render: () => ({
    template: `
      <div style="background: rgba(92, 10, 49, 0.9);">
        <app-header-top></app-header-top>
      </div>
    `,
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-header-top')).toBeTruthy();
  },
};
